import { useState, useEffect } from 'react';

export const useOnScreen = (ref, rootMargin = '0px') => {
    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) { return; }
        const observer = new IntersectionObserver(
            ([entry]) => setIntersecting(entry.isIntersecting),
            { root: null, rootMargin, threshold: 0.1 }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [ref, rootMargin]);

    return isIntersecting;
};

export default useOnScreen;
